import type { ApiClientKind } from '@/api/client'

/**
 * The React Query keys Integrations reads and invalidates, defined once so a
 * `useQuery` and the `invalidateQueries` that refreshes it cannot drift apart.
 * Each `…All` key is the prefix that invalidates every client kind's entry.
 */
export const integrationKeys = {
  summaryAll: ['integration-summary'] as const,
  summary: (provider: string, kind: ApiClientKind) => ['integration-summary', provider, kind] as const,
  metaAll: ['meta-integration'] as const,
  meta: (kind: ApiClientKind) => ['meta-integration', kind] as const,
  adAccountsAll: ['meta-ad-accounts'] as const,
  adAccounts: (kind: ApiClientKind) => ['meta-ad-accounts', kind] as const,
  websites: (kind: ApiClientKind) => ['integration-websites', kind] as const,
}
